module.exports = __webpack_public_path__ + "static/js/pigeon-worker.b9cd3574.chunk.worker.js"